import type { JournalCategory } from "@/types/api";
import { request } from "./transport";

export const journalCategories = {
  listJournalCategories: () =>
    request<{ journal_categories: JournalCategory[] }>("/journal_categories"),

  createJournalCategory: (name: string) =>
    request<{ journal_category: JournalCategory }>("/journal_categories", {
      method: "POST",
      body: JSON.stringify({ journal_category: { name } }),
    }),

  updateJournalCategory: (id: string, patch: { name?: string }) =>
    request<{ journal_category: JournalCategory }>(
      `/journal_categories/${id}`,
      {
        method: "PATCH",
        body: JSON.stringify({ journal_category: patch }),
      },
    ),

  reorderJournalCategories: (journalCategoryIds: string[]) =>
    request<{ journal_categories: JournalCategory[] }>(
      "/journal_categories/reorder",
      {
        method: "PATCH",
        body: JSON.stringify({ journal_category_ids: journalCategoryIds }),
      },
    ),

  deleteJournalCategory: (id: string) =>
    request<{ ok: true }>(`/journal_categories/${id}`, {
      method: "DELETE",
    }),
};
